import { getFragmentData } from 'gql'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { YIELDBIRD_DEMAND_REPORT } from './api/fragment'
import { GET_YIELDBIRD_DEMAND_REPORT } from './api/query'

import type {
  UseGetYieldbirdDemandReport,
  UseGetYieldbirdDemandReportProps,
  YieldbirdDemandReport,
} from './types'
import type {
  GetYieldbirdDemandReportQuery,
  GetYieldbirdDemandReportQueryVariables,
  YieldbirdDemandReportFragment,
} from 'gql/graphql'

export const useGetYieldbirdDemandReport = ({
  workspaceId: id,
}: UseGetYieldbirdDemandReportProps): UseGetYieldbirdDemandReport => {
  const { data } = useQuery<
    GetYieldbirdDemandReportQueryVariables,
    GetYieldbirdDemandReportQuery,
    YieldbirdDemandReport
  >({
    options: {
      select: ({ node }: GetYieldbirdDemandReportQuery): null | YieldbirdDemandReportFragment =>
        getFragmentData(YIELDBIRD_DEMAND_REPORT, node),
    },
    query: GET_YIELDBIRD_DEMAND_REPORT,
    variables: { id },
  })

  return {
    yieldbirdDemandReport: data,
  }
}
